import { styled } from '@mui/material/styles'

const PREFIX = 'FavoriteMenu'

export const classes = {
  title: `${PREFIX}-title`,
  favoritesList: `${PREFIX}-favoritesList`,
  item: `${PREFIX}-item`,
  removeIcon: `${PREFIX}-removeIcon`,
}

export const Root = styled('div')(({ theme }) => ({
  [`& .${classes.title}`]: {
    padding: 16,
  },

  [`& .${classes.favoritesList}`]: {
    width: '90%',
    maxHeight: '40%',
    marginLeft: 16,
    maxWidth: 360,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    backgroundColor: theme.palette.background.paper,
  },

  [`& .${classes.item}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: 2,
  },
  [`& .${classes.removeIcon}`]: {
    cursor: 'pointer',
  },
}))
